function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChillerWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3",
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.38,14.43 H 61.999999 V 71.310001 H 15.38 Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.42,30.36C43,33.44,37.73,35.92,32.64,32s-3.95-9.63-1.53-12.71c4.2-5.36,17.15-7.19,17.15-7.19S49.62,25,45.42,30.36Z",
    style: {
      strokeWidth: 2,
      fill: "#fff",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,29.82A5,5,0,0,1,33,26.94a5,5,0,0,1-.18-4.21",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.86,43.05a6.27,6.27,0,0,1-9,1.14,6.18,6.18,0,0,1-1.09-9c3-3.79,12.13-5.09,12.13-5.09S58.83,39.26,55.86,43.05Z",
    style: {
      strokeWidth: 2,
      fill: "#fff",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.22,42.67a4,4,0,0,1-2.29-5",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.46,24.19a6.26,6.26,0,0,1-9,1.14,6.18,6.18,0,0,1-1.09-9c3-3.78,12.13-5.08,12.13-5.08S67.44,20.41,64.46,24.19Z",
    style: {
      strokeWidth: 2,
      fill: "#fff",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.82,23.81a3.5,3.5,0,0,1-2.16-2,3.53,3.53,0,0,1-.13-3",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 31.99,39.77 V 67.68",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.6px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26.73,41.4 5.3,5.11 5.23,-5.11",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.6px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.26,66.07 -5.3,-5.11 -5.23,5.11",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.6px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 19.84,46.75 44.150002,60.700001",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.6px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18.62,52.09 7.1,-2 -1.84,-7.06",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.6px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.38,55.37 -7.11,2 1.85,7.06",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.6px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 19.84,60.709999 44.150002,46.759998",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.6px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "line32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23.88,64.43 1.81,-7.12 -7.07,-1.94",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.6px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 40.12,43.03 -1.81,7.12 7.07,1.94",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.6px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChillerWater);
export default __webpack_public_path__ + "static/media/chiller_water.3bfc02527c13a1a835eb85a4a96bec72.svg";
export { ForwardRef as ReactComponent };